import { createAction } from 'redux-act';
// add Department action
const addTrainingCertificateRequest = createAction('ADD_TRAININGCERTIFICATE_REQUEST', data => data);
const addTrainingCertificateSuccess = createAction('ADD_TRAININGCERTIFICATE_SUCCESS', data => data);
const addTrainingCertificateError = createAction('ADD_TRAININGCERTIFICATE_ERROR');

// get Department action
const getTrainingCertificatesRequest = createAction('GET_TRAININGCERTIFICATE_REQUEST', data => data);
const getTrainingCertificatesSuccess = createAction('GET_TRAININGCERTIFICATE_SUCCESS', data => data);
const getTrainingCertificatesError = createAction('GET_TRAININGCERTIFICATE_ERROR');

// get Department action
const updateTrainingCertificateRequest = createAction('UPDATE_TRAINING_CERTIFICATE_REQUEST', data => data);
const updateTrainingCertificateSuccess = createAction('UPDATE_TRAINING_CERTIFICATE_SUCCESS', data => data);
const updateTrainingCertificateError = createAction('UPDATE_TRAINING_CERTIFICATE_ERROR');

// get Department action
const deleteTrainingCertificateRequest = createAction('DELETE_TRAINING_CERTIFICATE_REQUEST', data => data);
const deleteTrainingCertificateSuccess = createAction('DELETE_TRAINING_CERTIFICATE_SUCCESS', data => data);
const deleteTrainingCertificateError = createAction('DELETE_TRAINING_CERTIFICATE_ERROR');

// get Department action
const getAllTrainingCertificatesRequest = createAction('GET_ALL_TRAINING_CERTIFICATES_REQUEST', data => data);
const getAllTrainingCertificatesSuccess = createAction('GET_ALL_TRAINING_CERTIFICATES_SUCCESS', data => data);
const getAllTrainingCertificatesError = createAction('GET_ALL_TRAINING_CERTIFICATES_ERROR');


// clear existing Department action
const handleClearTrainingCertificateStore = createAction('HANDLE_CLEAR_TRAINING_CERTIFICATE_STORE', data => data);
// const toastMsgAction = createAction('SUCCESS', data=> data);

export default {
    addTrainingCertificateRequest,
    addTrainingCertificateSuccess,
    addTrainingCertificateError,

    getTrainingCertificatesRequest,
    getTrainingCertificatesSuccess,
    getTrainingCertificatesError,

    updateTrainingCertificateRequest,
    updateTrainingCertificateSuccess,
    updateTrainingCertificateError,

    deleteTrainingCertificateRequest,
    deleteTrainingCertificateSuccess,
    deleteTrainingCertificateError,

    getAllTrainingCertificatesRequest,
    getAllTrainingCertificatesSuccess,
    getAllTrainingCertificatesError,


    handleClearTrainingCertificateStore,
    // toastMsgAction,

}